import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledAudioContainerProps {
  theme: any;
}

export const StyledBeforeAfterContainer = styled.div<StyledAudioContainerProps>`
  margin: ${pxToRem(20)};

  legend {
    margin: ${pxToRem(10)} 0;
  }
`

export const BeforeAfterContainer = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  user-select: none;
`;